import script from "./RestockTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./RestockTable.vue?vue&type=script&lang=ts&setup=true"

import "./RestockTable.vue?vue&type=style&index=0&id=c2922ae2&lang=scss"
import "./RestockTable.vue?vue&type=style&index=1&id=c2922ae2&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2922ae2"]])

export default __exports__